module.exports = __webpack_public_path__ + "img/question_tooltip.e52b338a.svg";